import { lazy } from 'react';

// Lazy load components for code splitting with preloading
export const LazyProjects = lazy(() => 
  import(/* webpackChunkName: "projects" */ '../components/Projects')
);

export const LazyContact = lazy(() => 
  import(/* webpackChunkName: "contact" */ '../components/Contact')
);

export const LazySkills = lazy(() => 
  import(/* webpackChunkName: "skills" */ '../components/Skills')
);

// Preload all components immediately
const preloadAllComponents = () => {
  Promise.all([
    import('../components/Projects'),
    import('../components/Contact'),
    import('../components/Skills')
  ]).catch(console.error);
};

// Start preloading immediately
preloadAllComponents();

// Preload components for better performance
export const preloadComponents = () => {
  // Preload components immediately after initial render
  setTimeout(() => {
    import('../components/Projects');
    import('../components/Contact');
    import('../components/Skills');
  }, 100); // Reduced from 1000ms to 100ms
};

// Preload components on user interaction
export const preloadOnInteraction = () => {
  const preloadComponents = () => {
    import('../components/Projects');
    import('../components/Contact');
    import('../components/Skills');
  };

  // Preload on first user interaction
  const events = ['mousedown', 'touchstart', 'keydown'];
  const preloadOnce = () => {
    preloadComponents();
    events.forEach(event => {
      document.removeEventListener(event, preloadOnce);
    });
  };

  events.forEach(event => {
    document.addEventListener(event, preloadOnce, { once: true, passive: true });
  });
};